import Init from "../pages/admin/assist_control/index";
import Users from "../pages/admin/users/index";
import CreateUser from "../pages/admin/users/create";
import UpdateUser from "../pages/admin/users/update";
import GroupList from '../pages/admin/groups/index';
import CreateGroup from '../pages/admin/groups/create';
import UpdateGroup from '../pages/admin/groups/update';
import Provinces from "./admin/provinces";
import Cities from "./admin/cities";
import Zones from "./admin/zones";
import Stores from "./admin/stores";
import Teams from "./admin/teams";
import Observations from "./admin/observations";
import UpdateObservation from "./admin/observations/update";
import ResultStates from "./admin/result_states";
import UpdateTeam from "./admin/teams/update";
import CriticalLevels from "./admin/critical_levels";
import WorkSheets from "./admin/work_sheets/index";
import UpdateWorkSheet from "./admin/work_sheets/update";
import UpdateWorkProcess from "./admin/work_process/update";
import UpdateWorkSubProcess from "./admin/work_subprocess/update";
import UpdateWorkActivity from "./admin/work_activities/update";
import Activities from "./admin/activities/index";
import ActivityItem from "./admin/activities/item";
import ConsultationsAssistControl from "./admin/assist_control/consultations";
import FindingsMatrix from "./admin/findings_matrix";
import FilesConsultations from "./admin/files_consultations";
import ResultsQuery from "./admin/results_query";
import ResultsQueryItem from "./admin/results_query/item";
import ResultsQueryProcess from "./admin/results_query/process";
import MonthlyMonitoring from "./admin/monthly_monitoring/index";
import MonthlyMonitoringItem from "./admin/monthly_monitoring/item";
import MonthlyMonitoringProcess from "./admin/monthly_monitoring/process";
import Matrix from "./admin/matrix";
import MatrixItem from "./admin/matrix/item";
import Societies from '../pages/admin/societies'
import Responsibles from '../pages/admin/responsibles'
import UpdateAcivity from '../pages/admin/activities/update_activity'


const routes = [
    {
        path: "/",
        name: "inicio",
        icon: "bx bx-home",
        exact: true,
        component: Init,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Inicio",
            permission_required: [
                "view_assistcontrol",
            ],
        },
    },
    {
        path: "/actividades/:idUsuario/:nombreUsuario/:idTienda/:nombreTienda/:fechaInicio/:fechaFin",
        name: "actividades",
        icon: "bx bx-calendar-check",
        exact: true,
        component: Activities,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Agenda",
            permission_required: [
                "view_activities",
            ],
        },
    },
    {
        path: "/actividad/detalle/:id/:idUsuario/:nombreUsuario/:idTienda/:nombreTienda/:fechaInicio/:fechaFin",
        name: "actividades",
        icon: "bx bx-calendar-check",
        exact: true,
        component: ActivityItem,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Agenda",
            permission_required: [
                "view_activities",
            ],
        },
    },
    {
        path: "/segumiento-mensual",
        name: "segumiento-mensual",
        icon: "bx bx-calendar-alt",
        exact: true,
        component: MonthlyMonitoring,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Seguimiento mensual",
            permission_required: [
                "view_activities",
            ],
        },
    },
    {
        path: "/seguimiento/:id/:nombre/:id_user/:user/:id_store/:store/:mes/:anio",
        name: "segumiento-mensual",
        icon: "bx bx-home",
        exact: true,
        component: MonthlyMonitoringItem,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Seguimiento mensual",
            permission_required: [
                "view_activities",
            ],
        },
    },
    {
        path: "/seguimiento/:id_hoja_trabajo/:hoja_trabajo/:id_proceso_trabajo/:proceso/:mes/:anio/:id_usuario/:usuario/:id_tienda/:tienda",
        name: "segumiento-mensual",
        icon: "bx bx-home",
        exact: true,
        component: MonthlyMonitoringProcess,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Seguimiento mensual",
            permission_required: [
                "view_activities",
            ],
        },
    },
    {
        path: "/consultas/control-asistencia",
        name: "consultas",
        icon: "bx bx-search",
        exact: true,
        component: ConsultationsAssistControl,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Control de asistencia",
            permission_required: [
                "view_assistcontrol",
            ],
        },
    },
    {
        path: "/consulta-resultados",
        name: "consulta-resultados",
        icon: "bx bxs-file-find",
        exact: true,
        component: ResultsQuery,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Consulta de resultados",
            permission_required: [
                "view_activities",
            ],
        },
    },
    {
        path: "/resultado/:id_hoja_trabajo/:nombre/:id_store/:tienda/:fecha_inicio/:fecha_fin",
        name: "consulta-resultados",
        icon: "bx bxs-file-find",
        exact: true,
        component: ResultsQueryItem,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Consulta de resultados",
            permission_required: [
                "view_activities",
            ],
        },
    },
    {
        path: "/resultado/procesos/:id_hoja_trabajo/:nombre/:id_tienda/:tienda/:fecha_inicio/:fecha_fin",
        name: "consulta-resultados",
        icon: "bx bxs-file-find",
        exact: true,
        component: ResultsQueryProcess,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Consulta de resultados",
            permission_required: [
                "view_activities",
            ],
        },
    },
    {
        path: "/consulta-archivos",
        name: "consulta-archivos",
        icon: "bx bxs-file-doc",
        exact: true,
        component: FilesConsultations,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Consulta de archivos",
            permission_required: [
                "view_activities",
            ],
        },
    },
    {
        path: "/matriz",
        name: "consulta-matriz",
        icon: "bx bx-search-alt",
        exact: true,
        component: Matrix,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Consulta de matríz",
            permission_required: [
                "view_findingsmatrix",
            ],
        },
    },
    {
        path: "/matriz-item/:id_matriz/:nombre",
        name: "consulta-matriz",
        icon: "bx bx-search-alt",
        exact: true,
        component: MatrixItem,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Consulta de matríz",
            permission_required: [
                "view_findingsmatrix",
            ],
        },
    },
    {
        path: "/solicitud-ediciones",
        name: "solicitud-ediciones",
        icon: "bx bx-file",
        exact: true,
        component: UpdateAcivity,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Solicitud de ediciones",
            permission_required: [
                "aprobar_solicitud_edicion",
            ],
        },
    },
    {
        path: "/hojas-trabajos",
        name: "hojas-trabajos",
        icon: "bx bxs-spreadsheet",
        exact: true,
        component: WorkSheets,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Hojas trabajos",
            permission_required: [
                "view_worksheets",
            ],
        },
    },
    {
        path: "/hoja-trabajo/detalle/:id",
        name: "hojas-trabajos",
        icon: "bx bxs-spreadsheet",
        exact: true,
        component: UpdateWorkSheet,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Hojas trabajos",
            permission_required: [
                "change_worksheets",
            ],
        },
    },
    {
        path: "/proceso-trabajo/detalle/:id_work_sheet/:id",
        name: "procesos-trabajos",
        icon: "bx bxs-spreadsheet",
        exact: true,
        component: UpdateWorkProcess,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Procesos de trabajos",
            permission_required: [
                "change_workprocess",
            ],
        },
    },
    {
        path: "/subproceso-trabajo/detalle/:id_work_sheet/:id_work_process/:id",
        name: "subprocesos-trabajos",
        icon: "bx bxs-spreadsheet",
        exact: true,
        component: UpdateWorkSubProcess,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Subprocesos de trabajos",
            permission_required: [
                "change_worksubprocess",
            ],
        },
    },
    {
        path: "/actividad-trabajo/detalle/:id_work_sheet/:id_work_process/:id_work_subprocess/:id",
        name: "subprocesos-trabajos",
        icon: "bx bxs-spreadsheet",
        exact: true,
        component: UpdateWorkActivity,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Actividad de trabajos",
            permission_required: [
                "change_workactivities",
            ],
        },
    },
    {
        path: "/matriz-hallazgo",
        name: "matriz-hallazgo",
        icon: "bx bx-list-plus",
        exact: true,
        component: FindingsMatrix,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Matriz de hallazgo",
            permission_required: [
                "view_findingsmatrix",
            ],
        },
    },
    {
        path: "/equipos",
        name: "equipos",
        icon: "bx bxs-user-plus",
        exact: true,
        component: Teams,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Equipos",
            permission_required: [
                "view_teams",
            ],
        },
    },
    {
        path: "/equipo/detalle/:id",
        name: "equipos",
        icon: "bx bxs-user-plus",
        exact: true,
        component: UpdateTeam,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Equipos",
            permission_required: [
                "change_teams",
            ],
        },
    },
    {
        path: "/observaciones",
        name: "observaciones",
        icon: "bx bx-list-ol",
        exact: true,
        component: Observations,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Observaciones",
            permission_required: [
                "view_observations",
            ],
        },
    },
    {
        path: "/observacion/detalle/:id",
        name: "observaciones",
        icon: "bx bx-list-ol",
        exact: true,
        component: UpdateObservation,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Observaciones",
            permission_required: [
                "change_observations",
            ],
        },
    },
    {
        path: "/estados-resultados",
        name: "estados-resultados",
        icon: "bx bx-info-circle",
        exact: true,
        component: ResultStates,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Estados de resultados",
            permission_required: [
                "view_resultstates",
            ],
        },
    },
    {
        path: "/niveles-criticos",
        name: "niveles-criticos",
        icon: "bx bxs-archive-in",
        exact: true,
        component: CriticalLevels,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Niveles críticos",
            permission_required: [
                "view_criticallevels",
            ],
        },
    },
    {
        path: "/responsables",
        name: "responsables",
        icon: "bx bxs-archive-in",
        exact: true,
        component: Responsibles,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Responsables",
            permission_required: [
                "view_responsibles",
            ],
        },
    },
    {
        path: "/provincias",
        name: "provincias",
        icon: "bx bxs-map-alt",
        exact: true,
        component: Provinces,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Provincias",
            permission_required: [
                "view_provinces",
            ],
        },
    },
    {
        path: "/ciudades",
        name: "ciudades",
        icon: "bx bxs-city",
        exact: true,
        component: Cities,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Ciudades",
            permission_required: [
                "view_cities",
            ],
        },
    },
    {
        path: "/sociedades",
        name: "sociedades",
        icon: "bx bxs-buildings",
        exact: true,
        component: Societies,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Sociedades",
            permission_required: [
                "view_societies",
            ],
        },
    },
    {
        path: "/zonas",
        name: "zonas",
        icon: "bx bx-building",
        exact: true,
        component: Zones,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Zonas",
            permission_required: [
                "view_zones",
            ],
        },
    },
    {
        path: "/tiendas",
        name: "tiendas",
        icon: "bx bxs-store",
        exact: true,
        component: Stores,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Tiendas",
            permission_required: [
                "view_stores",
            ],
        },
    },
    {
        path: "/roles",
        name: "roles",
        icon: "bx bxs-user-pin",
        exact: true,
        component: GroupList,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Roles",
            permission_required: [
                "view_group",
            ],
        },
    },
    {
        path: "/roles/crear",
        name: "roles",
        icon: "bx bxs-user",
        exact: true,
        component: CreateGroup,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Roles",
            permission_required: [
                "add_group",
            ],
        },
    },
    {
        path: "/roles/editar/:id",
        name: "roles",
        icon: "bx bxs-user",
        exact: true,
        component: UpdateGroup,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Roles",
            permission_required: [
                "change_group",
            ],
        },
    },
    {
        path: "/usuarios",
        name: "usuarios",
        icon: "bx bxs-user",
        exact: true,
        component: Users,
        show_in_menu: true,
        meta: {
            requiresAuth: true,
            title: "Usuarios",
            permission_required: [
                "view_user",
            ],
        },
    },
    {
        path: "/usuarios/crear",
        name: "usuarios",
        icon: "bx bxs-user",
        exact: true,
        component: CreateUser,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Usuarios",
            permission_required: [
                "add_user",
            ],
        },
    },
    {
        path: "/usuarios/editar/:id",
        name: "usuarios",
        icon: "bx bxs-user",
        exact: true,
        component: UpdateUser,
        show_in_menu: false,
        meta: {
            requiresAuth: true,
            title: "Usuarios",
            permission_required: [
                "change_user",
            ],
        },
    },
];

export default routes;
